/* La Perse — PDP Gallery
   Thumb clicks, prev/next, keyboard ←/→ */
(function () {
  'use strict';

  function init(gallery) {
    if (!gallery || gallery.dataset.initialised === 'true') return;
    gallery.dataset.initialised = 'true';

    var stage = gallery.querySelector('[data-pdp-stage]');
    var mainImg = stage && stage.querySelector('[data-main-image]');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-thumb]'));
    var prev = gallery.querySelector('[data-prev]');
    var next = gallery.querySelector('[data-next]');
    if (!mainImg || thumbs.length === 0) return;

    var index = 0;

    function setActive(i) {
      if (i < 0) i = thumbs.length - 1;
      if (i >= thumbs.length) i = 0;
      index = i;

      thumbs.forEach(function (t, j) {
        var on = j === index;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      var src = thumbs[index].dataset.src;
      var srcset = thumbs[index].dataset.srcset;
      var alt = thumbs[index].dataset.alt;
      if (src) mainImg.src = src;
      if (srcset) mainImg.srcset = srcset;
      if (alt) mainImg.alt = alt;
    }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { setActive(i); });
    });
    if (prev) prev.addEventListener('click', function () { setActive(index - 1); });
    if (next) next.addEventListener('click', function () { setActive(index + 1); });

    gallery.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); setActive(index - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); setActive(index + 1); }
    });
  }

  document.querySelectorAll('[data-pdp-gallery]').forEach(init);
})();